import formatBalance from "services/helper/formatBalance";

export class UserApiConverter {

  convertUsersList = data => ({
    users: data?.users || [],
    quantity: data?.quantity || 0,
    totalBalance: formatBalance(data?.balance_sum) || 0,
  });

  convertNewPassword = data => data.new_password;
}